module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/promoCoins-440abbac30a8288fda415e27b50eff49.png";